// // src/main.js
// import { createApp } from 'vue'; // Import hàm createApp từ Vue 3
// import { createPinia } from 'pinia'; // Import createPinia để khởi tạo Pinia
// import App from './App.vue'; // Component gốc của ứng dụng
// import router from './router'; // Import Vue Router instance

// // Import thư viện Toast và CSS của nó
// import Toast, { POSITION } from "vue-toastification";
// import "vue-toastification/dist/index.css";

// // Tạo instance Pinia
// const pinia = createPinia();

// // Tạo ứng dụng Vue
// const app = createApp(App);

// // Sử dụng các plugin và thư viện
// app.use(router); // Gắn Vue Router vào ứng dụng
// app.use(pinia); // Gắn Pinia vào ứng dụng

// // Cấu hình và gắn thư viện Toast vào ứng dụng
// const toastOptions = {
//   position: POSITION.TOP_RIGHT,
//   timeout: 3000
// };

// app.use(Toast, toastOptions);

// // Gắn ứng dụng Vue vào phần tử DOM có id="app"
// app.mount('#app');

// src/main.js
// src/main.js
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useAuthStore } from "./stores/auth";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

import vCan from "@/directives/v-can";
import vApi from "@/directives/v-api";
import RBAC from "./api/rbac";

const pinia = createPinia();
const app = createApp(App);

app.directive("can", vCan);
app.directive("api", vApi);
app.use(router);
app.use(pinia);
app.use(FloatingVue);
// Khởi tạo Auth Store VÀ gọi hàm initialize() ngay lập tức
RBAC.init(pinia)
const authStore = useAuthStore();
authStore.initialize();

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
};
app.component("vue-multiselect", VueMultiselect);

app.use(Toast, toastOptions);
app.mount("#app");

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log(
          "✅ ServiceWorker đã được đăng ký thành công:",
          registration
        );
      })
      .catch((registrationError) => {
        console.log("❌ Lỗi khi đăng ký ServiceWorker:", registrationError);
      });
  });
}
